export default {"src":"/_next/static/media/pay-with.db4128aa.svg","height":100,"width":1826};